import { render, staticRenderFns } from "./TelegramConnection.vue?vue&type=template&id=b7b8f954&"
import script from "./TelegramConnection.vue?vue&type=script&lang=babel&"
export * from "./TelegramConnection.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports